
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/all_collections",
      function () {
        return require("private-next-pages/all_collections/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/all_collections"])
      });
    }
  